import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";


const OperationalUpdatesList = Loadable(
  lazy(() =>
    import("./OperationalUpdatesList").then(({ OperationalUpdatesList }) => ({
      default: OperationalUpdatesList,
    }))
  )
);
export const operationalUpdatesRoutes = [
  {
    path: `/operational-updates`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <OperationalUpdatesList />
      </AuthorizedRoute>
    ),
  },
]